import { render, staticRenderFns } from "./EmployeeSummaryInfo.vue?vue&type=template&id=6ac4f45e&scoped=true&lang=pug"
import script from "./EmployeeSummaryInfo.vue?vue&type=script&lang=ts"
export * from "./EmployeeSummaryInfo.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSummaryInfo.vue?vue&type=style&index=0&id=6ac4f45e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac4f45e",
  null
  
)

export default component.exports